import { DateTime } from "luxon";

type Translate = (key: string, options?: Record<string, string>) => string;

function dateLocale(language: string): "de" | "en" {
  if (language.startsWith("de")) {
    return "de";
  }
  return "en";
}

export function formatPermissionDate(isoDate: string, language: string): string {
  const locale = dateLocale(language);
  const dt = DateTime.fromISO(isoDate, { zone: "utc" }).setLocale(locale);
  if (!dt.isValid) {
    return isoDate;
  }
  return dt.toFormat(locale === "de" ? "d. LLL yyyy" : "d LLL yyyy");
}

export function formatPermissionDateRange(
  startIso: string,
  endIso: string,
  language: string
): string {
  const locale = dateLocale(language);
  const start = DateTime.fromISO(startIso, { zone: "utc" }).setLocale(locale);
  const end = DateTime.fromISO(endIso, { zone: "utc" }).setLocale(locale);
  if (!start.isValid || !end.isValid) {
    return `${startIso} – ${endIso}`;
  }

  if (start.hasSame(end, "month") && start.hasSame(end, "year")) {
    if (locale === "de") {
      return `${start.day}.–${end.day}. ${start.toFormat("LLL yyyy")}`;
    }
    return `${start.day}–${end.day} ${start.toFormat("LLL yyyy")}`;
  }

  return `${formatPermissionDate(startIso, language)} – ${formatPermissionDate(endIso, language)}`;
}

export function formatPermissionWindowLabel(
  window: { start: string; end: string | null },
  language: string,
  t: Translate
): string {
  if (window.end) {
    return t("_scheduleResource_notPermittedWindowRange", {
      range: formatPermissionDateRange(window.start, window.end, language)
    });
  }
  return t("_scheduleResource_notPermittedWindowFrom", {
    date: formatPermissionDate(window.start, language)
  });
}
